export const FETCH_TASK_PROFILES = 'FETCH_TASK_PROFILES';
export const FETCHING_TASK_PROFILES = 'FETCHING_TASK_PROFILES';
export const FETCH_TASK_PROFILES_SUCCESS = 'FETCH_TASK_PROFILES_SUCCESS';
export const FETCH_TASK_PROFILES_FAILED = 'FETCH_TASK_PROFILES_FAILED';

export const FETCH_TASK_PROFILE = 'FETCH_TASK_PROFILE';
export const FETCHING_TASK_PROFILE = 'FETCHING_TASK_PROFILE';
export const FETCH_TASK_PROFILE_SUCCESS = 'FETCH_TASK_PROFILE_SUCCESS';
export const FETCH_TASK_PROFILE_FAILED = 'FETCH_TASK_PROFILE_FAILED';

export function fetchTaskProfiles() {
  return {
    type: FETCH_TASK_PROFILES,
  };
}

export function fetchingTaskProfiles() {
  return {
    type: FETCHING_TASK_PROFILES,
  };
}

export function fetchTaskProfilesSuccess(taskProfiles) {
  return {
    type: FETCH_TASK_PROFILES_SUCCESS,
    taskProfiles,
  };
}

export function fetchTaskProfilesFailed(err) {
  return {
    type: FETCH_TASK_PROFILES_FAILED,
    message: err.message,
  };
}

export function fetchTaskProfile(taskProfileId) {
  return {
    type: FETCH_TASK_PROFILE,
    taskProfileId,
  };
}

export function fetchingTaskProfile(taskProfileId) {
  return {
    type: FETCHING_TASK_PROFILE,
    taskProfileId,
  };
}

export function fetchTaskProfileSuccess(taskProfile) {
  return {
    type: FETCH_TASK_PROFILE_SUCCESS,
    taskProfile,
  };
}

export function fetchTaskProfileFailed(taskProfileId,err) {
  return {
    type: FETCH_TASK_PROFILE_FAILED,
    taskProfileId,
    message: err.message,
  };
}



// WEBPACK FOOTER //
// ./src/actions/taskprofiles.js